import React from 'react';
import Heading from '@atlaskit/heading';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';
import { Spotlight, SpotlightTransition } from '@atlaskit/onboarding';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { useRenderControllerState } from '../../controllers';
import messages from './messages';

// Refer - @atlassian/jira-atlassian-navigation/src/common/constants for the below constants
// Moved to this file to avoid cyclic dependency
const HELP_SPOTLIGHT_KEY = 'help-spotlight';

export const BipgSpotlight = () => {
	const { formatMessage } = useIntl();
	const [{ shouldRenderReopenSpotlight }, { setShouldRenderReopenSpotlight }] =
		useRenderControllerState();

	if (!shouldRenderReopenSpotlight) return null;

	return (
		<SpotlightTransition>
			<Spotlight
				actions={[
					{
						onClick: () => setShouldRenderReopenSpotlight(false),
						text: 'OK',
					},
				]}
				header={() => (
					<Heading size="small">{formatMessage(messages.spotlightHeaderNonFinal)}</Heading>
				)}
				heading={formatMessage(messages.spotlightHeaderNonFinal)}
				target={HELP_SPOTLIGHT_KEY}
				key={HELP_SPOTLIGHT_KEY}
				targetRadius={24}
				dialogWidth={304}
			>
				<p>
					{formatMessage(messages.spotlightContentNonFinal, {
						bold: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
						icon: () => (
							<QuestionCircleIcon
								primaryColor={token('color.icon.inverse', colors.N0)}
								secondaryColor={token('color.icon.accent.purple', colors.P500)}
								size="small"
								label=""
							/>
						),
					})}
				</p>
			</Spotlight>
		</SpotlightTransition>
	);
};
